import { useDataProvider } from 'ra-core';
import { useQuery } from '@tanstack/react-query';
import { type AdminDataProvider } from '../adminDataProvider';

export const useFetchSendBirdAppId = (options?: { enabled?: boolean }) => {
  const provider = useDataProvider<AdminDataProvider>();

  return useQuery({
    queryKey: ['fetch-send-bird-app-id'],
    queryFn: provider.fetchSendBirdAppId,
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60,
  });
};
